<template>
  <div class="min-h-screen bg-black text-white p-4 sm:p-6 md:p-8">
    <div class="max-w-7xl mx-auto">
      <!-- Header -->
      <div class="text-center mb-12 border-b-2 border-yellow-500 pb-8">
        <h1 class="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-yellow-500">🥁 PANTALLAS EN VIVO 🥁</h1>
        <p class="text-sm sm:text-base md:text-lg text-yellow-400">Selecciona una categoría para abrirla en pantalla independiente</p>
      </div>

      <!-- Torneos -->
      <div v-if="torneos.length" class="space-y-12">
        <div v-for="torneo in torneos" :key="torneo.id" class="bg-gradient-to-r from-gray-800 to-gray-900 p-8 rounded-lg border border-yellow-500 border-opacity-30">
          <div class="flex items-center justify-between mb-8">
            <h2 class="text-2xl font-bold text-yellow-500 uppercase tracking-wide">{{ torneo.nombre }}</h2>
            <router-link
              :to="`/public/podio/${torneo.id}`"
              class="bg-yellow-600 hover:bg-yellow-500 text-black font-bold py-2 px-4 rounded-lg transition-colors whitespace-nowrap"
            >
              🏆 Ver Podio
            </router-link>
          </div>

          <!-- Pantallas por Tatami -->
          <p class="text-sm text-orange-400 font-semibold mb-4 uppercase tracking-wide">🥋 Pantallas por Tatami</p>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
            <div
              v-for="t in totalTatamis"
              :key="`tatami-${t}`"
              class="bg-black border-2 border-orange-500 rounded-lg p-6 hover:shadow-lg hover:shadow-orange-500/50 transition-all cursor-pointer group"
              @click="abrirPantallaTatami(t, torneo.id)"
            >
              <div class="text-center">
                <p class="text-3xl font-bold text-orange-500 mb-2 group-hover:text-orange-400">Tatami {{ t }}</p>
                <button
                  class="w-full bg-orange-600 hover:bg-orange-500 text-black font-bold py-3 px-4 rounded-lg transition-colors"
                >
                  📺 ABRIR PANTALLA
                </button>
              </div>
            </div>
          </div>

          <!-- Pantallas por Categoría -->
          <p class="text-sm text-yellow-400 font-semibold mb-4 uppercase tracking-wide">Pantallas por Categoría</p>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div
              v-for="cat in torneo.categorias"
              :key="cat.categoria_id"
              class="bg-black border-2 border-yellow-500 rounded-lg p-6 hover:shadow-lg hover:shadow-yellow-500/50 transition-all cursor-pointer group"
              @click="abrirPantalla(cat.categoria_id, cat.nombre, torneo.id)"
            >
              <div class="text-center">
                <p class="text-3xl font-bold text-yellow-500 mb-2 group-hover:text-yellow-400">{{ cat.nombre }}</p>
                <p class="text-sm text-gray-400 mb-4">{{ cat.total_competidores || 0 }} competidores</p>
                <button
                  class="w-full bg-yellow-600 hover:bg-yellow-500 text-black font-bold py-3 px-4 rounded-lg transition-colors"
                >
                  📺 ABRIR PANTALLA
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sin torneos -->
      <div v-else class="text-center py-12">
        <p class="text-xl text-gray-400">No hay torneos disponibles</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useAPI } from '../../composables/useAPI'
import { TOTAL_TATAMIS } from '../../config'

const api = useAPI()
const torneos = ref([])
const totalTatamis = Array.from({ length: TOTAL_TATAMIS }, (_, i) => i + 1)

const abrirPantalla = (categoriaId, nombreCategoria, torneoId) => {
  // Abrir en nueva pestaña con torneoId y categoriaId
  window.open(`/public/pantalla/${torneoId}/${categoriaId}`, '_blank')
}

const abrirPantallaTatami = (tatami, torneoId) => {
  window.open(`/public/tatami/${torneoId}/${tatami}`, '_blank')
}

onMounted(async () => {
  try {
    torneos.value = await api.getTorneos()
  } catch (err) {
    console.error('Error cargando torneos:', err)
  }
})
</script>
